export default __webpack_public_path__ + "static/media/star-half.237393b1.svg";